export const BaseUrl = (window.location.href.includes("office365/render"))
    ? window.location.origin + "/jira"
    : window.location.href.substring(0, window.location.href.lastIndexOf('/'));
export const RootUrl = window.location.origin;